import { FileSpreadsheet, Warehouse, ShoppingCart, ReceiptIndianRupee, FileSignature } from "lucide-react";

export const DEPT_WRITERS = {
  qs: ["site_qs", "hod", "sr_president", "vc"],
  stores: ["stores"],
  purchase: ["purchase"],
  finance: ["finance"],
  contracts: ["contracts", "director"],
};

export const canWrite = (user, dept) => user?.role === "admin" || DEPT_WRITERS[dept]?.includes(user?.role);

const ALL_DEPTS = [
  {
    id: "qs", name: "QS & Billing", icon: FileSpreadsheet,
    items: [
      { slug: "ra-bills", label: "RA Bill Tracker", flagship: true },
      { slug: "tender-budget", label: "Tender Budget", module: "tender_budget" },
      { slug: "quantity-reconciliation", label: "Quantity Reconciliation", module: "quantity_recon" },
      { slug: "gfc-drawings", label: "GFC Drawings", module: "gfc_drawings" },
      { slug: "cashflow", label: "Cashflow", module: "cashflow" },
    ],
  },
  {
    id: "stores", name: "Store & Site Operations", icon: Warehouse,
    items: [
      { slug: "gate-entry", label: "Gate Entry", module: "gate_entries" },
      { slug: "grn", label: "GRN & Inspection", flagship: true },
      { slug: "stock-transfer", label: "Stock Transfer", module: "stock_transfers" },
      { slug: "physical-verification", label: "Physical Verification", module: "physical_verification" },
      { slug: "scrap-disposal", label: "Scrap Disposal", module: "scrap_disposal" },
    ],
  },
  {
    id: "purchase", name: "Purchase", icon: ShoppingCart,
    items: [
      { slug: "rfq", label: "RFQ & Tender", flagship: true },
      { slug: "vendors", label: "Vendor Master", module: "vendors" },
      { slug: "material-master", label: "Material Master", module: "materials" },
      { slug: "vendor-evaluation", label: "Vendor Evaluation", module: "vendor_evaluation" },
      { slug: "purchase-orders", label: "Purchase Orders", module: "purchase_orders" },
      { slug: "invoice-verification", label: "Invoice Verification", module: "invoice_verification" },
    ],
  },
  {
    id: "finance", name: "Finance", icon: ReceiptIndianRupee,
    items: [
      { slug: "invoices", label: "Invoice Queue", flagship: true },
      { slug: "gl-classification", label: "GL Classification", module: "gl_classification" },
      { slug: "gst-compliance", label: "GST Compliance", module: "gst_compliance" },
      { slug: "cash-flow-forecast", label: "Cash Flow Forecast", module: "cashflow_forecast" },
      { slug: "advance-recovery", label: "Advance Recovery", module: "advance_recovery" },
    ],
  },
  {
    id: "contracts", name: "Contracts", icon: FileSignature,
    items: [
      { slug: "vendor-prequalification", label: "Vendor Pre-Qualification", module: "vendor_prequal" },
      { slug: "tender-queries", label: "Tender Queries", module: "tender_queries" },
      { slug: "comparative-statement", label: "Comparative Statement", module: "comparative_statements" },
      { slug: "award", label: "Contract Award", flagship: true },
      { slug: "document-vault", label: "Document Vault", module: "document_vault" },
    ],
  },
];

const DASH_ITEM = { slug: "dashboard", label: "Dashboard", dashboard: true };

export const DEPTS = ["contracts", "purchase", "stores", "qs", "finance"]
  .map((id) => ALL_DEPTS.find((d) => d.id === id))
  .map((d) => ({ ...d, items: [DASH_ITEM, ...d.items] }));

export const findNav = (deptId, slug) => {
  const dept = DEPTS.find((d) => d.id === deptId);
  return { dept, item: dept?.items.find((i) => i.slug === slug) };
};
